import React from "react";
import Context from "../../../../../Context";
import BigError from "../../../../Misc/BigError";
import CrumbsProvider from "../../../../Misc/CrumbsProvider";
import Blocker from "../../../../Misc/Blocker";
import UserDeatilProfile from "./UserDeatilProfile";
import UserDeatilIP from "./UserDeatilIP";
import UserDeatilInterfaces from "./UserDeatilInterfaces";
import UserDetailAreas from "./UserDetailAreas";
import UserDeatilGroups from "./UserDeatilGroups";

import { Redirect } from "react-router-dom";

export default class UserDetail extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      pending: false,
      notFound: false,
      mode: "profile",
      user: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  pending = (pending) => {
    this.setState({ pending });
  };

  load = async () => {
    this.setState({ pending: true });
    let user = {};
    let notFound = false;
    let result = await this.context.api.q("/admin/user/get", {
      id: this.props.userId,
    });
    if (result !== false) {
      user = result;
    } else {
      notFound = true;
    }
    this.setState({ pending: false, notFound, user });
  };

  userLock = async () => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/admin/user/lock", {
      id: this.props.userId,
    });
    if (result !== false) {
      this.context.toast("Пользователь заблокирован", "success");
    } else {
      this.context.toast("Не удалось заблокировать пользователя", "error");
    }
    this.load();
  };

  userUnLock = async () => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/admin/user/unlock", {
      id: this.props.userId,
    });
    if (result !== false) {
      this.context.toast("Пользователь разблокирован", "success");
    } else {
      this.context.toast("Не удалось разблокирован пользователя", "error");
    }
    this.load();
  };

  userDeletePrompt = () => {
    this.context
      .ask(
        `Вы действительно хотите удалить пользователя ${this.state.user["id"]} ${this.state.user["name"]}`,
        "Удаление пользователя",
        "question"
      )
      .then((result) => {
        if (result.value) {
          this.userDelete();
        }
      });
  };

  userSuPrompt = async () => {
    let promptResult = await this.context.promptPassword();
    let password = promptResult.value;
    if (password) {
      let result = await this.context.api.q("/su", {
        username: this.state.user?.username,
        password,
      });
      if (result?.success) {
        document.location.reload();
      }
    }
  };

  userDelete = async () => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/admin/user/delete", {
      id: this.props.userId,
    });
    if (result !== false) {
      this.context.toast("Пользователь удален", "success");
      this.setState({ redirect: "/admin/users" });
    } else {
      this.context.toast("Не удалось удалить пользователя", "error");
      this.setState({ pending: false });
    }
  };

  renderNav() {
    let nav = {
      profile: "Профиль",
      groups: "Группы",
      areas: "Подразделения",
      ip: "IP Адреса",
      interfaces: "Интерфейсы",
    };
    return (
      <ul className="nav nav-tabs mb-10">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <span
              onClick={() => this.setState({ mode: id })}
              className={` ${
                this.state.mode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
            </span>
          </li>
        ))}
      </ul>
    );
  }

  renderUserButtons() {
    return (
      <div className="px-lg-15 mt-10 border-top pt-4">
        {this.state.user["lock_date"] ? (
          <button
            onClick={this.userUnLock}
            className="btn btn-light w-100 my-2"
          >
            Разблокировать
          </button>
        ) : (
          <button onClick={this.userLock} className="btn btn-light w-100 my-2">
            Заблокировать
          </button>
        )}

        <button
          onClick={this.userDeletePrompt}
          className="btn btn-light w-100 my-2"
        >
          Удалить
        </button>

        <button
          onClick={this.userSuPrompt}
          className="btn btn-light w-100 my-2"
        >
          Авторизоваться
        </button>
      </div>
    );
  }

  render() {
    if (this.state.redirect) return <Redirect to={this.state.redirect} />;
    if (this.state.notFound) {
      return (
        <BigError
          title={"Пользователь не найден"}
          message={`Не удалось получить информацию о пользователе #${this.props.userId}`}
        />
      );
    }
    return (
      <>
        <CrumbsProvider title="Карточка пользователя" />
        <div className="row">
          <div className="col-lg-4 mb-5 mb-lg-0">
            <div className="card card-custom card-stretch">
              <div className="card-body">
                <Blocker on={this.state.pending}>
                  <UserInfo user={this.state.user} />
                  {this.renderUserButtons()}
                </Blocker>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="card card-custom card-stretch">
              <div className="card-body">
                <Blocker on={this.state.pending}>
                  {this.renderNav()}
                  {this.state.mode === "profile" ? (
                    <UserDeatilProfile
                      onPending={this.pending}
                      onFinish={this.load}
                      user={this.state.user}
                    />
                  ) : null}
                  {this.state.mode === "areas" ? (
                    <UserDetailAreas
                      onPending={this.pending}
                      onFinish={this.load}
                      user={this.state.user}
                      key={this.state.user["id"]}
                    />
                  ) : null}
                  {this.state.mode === "ip" ? (
                    <UserDeatilIP
                      onPending={this.pending}
                      onFinish={this.load}
                      user={this.state.user}
                      key={this.state.user["id"]}
                    />
                  ) : null}
                  {this.state.mode === "interfaces" ? (
                    <UserDeatilInterfaces
                      onPending={this.pending}
                      onFinish={this.load}
                      user={this.state.user}
                      key={this.state.user["id"]}
                    />
                  ) : null}
                  {this.state.mode === "groups" ? (
                    <UserDeatilGroups
                      onPending={this.pending}
                      onFinish={this.load}
                      user={this.state.user}
                      key={this.state.user["id"]}
                    />
                  ) : null}
                </Blocker>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function UserInfo(props) {
  let user = props.user || {};
  let literal = user["name"] ? user["name"][0].toUpperCase() : null;

  return (
    <>
      <div className="d-flex align-items-center">
        <div className="symbol symbol-75 mr-5">
          {user.picture ? (
            <img alt="userpic" src={user.picture} />
          ) : (
            <span className="symbol-label bg-light-primary font-size-h4">
              {literal}
            </span>
          )}
          {user.status === 2 ? (
            <i className="symbol-badge bg-success symbol-badge-bottom"></i>
          ) : null}
        </div>
        <div>
          <h5>{user["name"]}</h5>
          <div className="font-size-sm text-muted">{user["description"]}</div>
        </div>
      </div>

      {user["lock_date"] ? (
        <span className="label bg-danger label-inline p-5 text-light w-100 my-4">
          Заблокирован {new Date(user["created"]).toLocaleString()}
        </span>
      ) : null}

      <div className="d-flex justify-content-between align-items-center my-4">
        <div>Создан</div>
        <div>
          {user["created"] ? new Date(user["created"]).toLocaleString() : "-"}
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center  my-4">
        <div>Последняя активность</div>
        <div>
          {user["input_last"]
            ? new Date(user["input_last"]).toLocaleString()
            : "-"}
        </div>
      </div>
    </>
  );
}
